var MpPageEquipmentsAdd;

(function() {
    if (!document.querySelector('#vue-body-equipment-new')) {
        return;
    }

    // Vue.component('multiselect', window.VueMultiselect.default);

    MpPageEquipmentsAdd = new Vue({
        el: '#vue-body-equipment-new',
        mixins: [MpVideoModal],
        data: {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            VALIDATION_OK: 1,
            VALIDATION_KO: 0,
            FORM_URL: '/equipment/new',

            hasForm: true,
            company: '',
            name: '',
            email: '',
            phone: '',
            fsecure: '',
            privacity: false,

            errors: [],
            successMessage: '',
            validated: false,

            isLegalShown: false,
            isInitialized: false,
        },

        computed: {

            companyCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.company);
            },

            nameCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.name);
            },

            emailCheck: function() {
                return !this.validated || (!FormValidator.isEmpty(this.email) && FormValidator.isValidEmail(this.email));
            },

            phoneCheck: function() {
                return !this.validated || (!FormValidator.isEmpty(this.phone) && FormValidator.isNumber(this.phone));
            },

            privacityCheck: function() {
                return (!this.validated || this.privacity);
            },

            dataForm: function() {
                return Serializer.serialize({
                    'company': this.company,
                    'company_name': this.name,
                    'email': this.email,
                    'phone': this.phone,
                    'fsecure': this.fsecure,
                    'privacity': (this.privacity) ? 'on' : '',
                });
            }
        },

        methods: {

            closeLegalModal: function() {
                noScroll.off();
                this.isLegalShown = false;
            },

            showLegalConditions: function(ev) {
                if (ev.target.tagName === 'A') {
                    ev.preventDefault();
                    noScroll.on();
                    this.isLegalShown = true;
                }
            },

            cleanErrors: function() {
                this.errors = [];
            },

            addError: function(errorMsg) {
                if (this.errors.length > 0) {
                    return;
                }

                this.errors.push(errorMsg);
            },

            validateForm: function() {
                /// data_ko, service_ko, error_data, error_privacity
                /// are globally injected from PHP controller
                var isValid = true;

                this.cleanErrors();
                this.validated = true;

                if (!this.companyCheck) {
                    this.addError(error_data);
                    isValid = false;
                }

                if (!this.nameCheck) {
                    this.addError(error_data);
                    isValid = false;
                }

                if (!this.emailCheck) {
                    this.addError(data_ko);
                    isValid = false;
                }

                if (!this.phoneCheck) {
                    this.addError(data_ko);
                    isValid = false;
                }

                if (!this.privacityCheck) {
                    isValid = false;
                    this.addError(error_privacity);
                }

                return isValid;
            },

            resetForm: function() {
                this.company = '';
                this.name = '';
                this.email = '';
                this.phone = '';
                this.privacity = false;

                this.validated = false;
                this.cleanErrors();
            },

            onSend: function(response) {
                if (response.data.result === 'OK') {
                    this.successMessage = response.data.message;
                    this.resetForm();
                } else {
                    this.addError(response.data.message);
                }
            },

            sendForm: function(ev) {
                this.successMessage = '';

                if (this.validateForm()) {
                    axios
                        .post(this.FORM_URL, this.dataForm)
                        .then(this.onSend)
                        .catch(function(error) {
                            console.log(error);
                        });
                }
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
            },
        },

        mounted: function() {

            hasForm = (this.$refs.newForm) ? true : false;

            if (hasForm) {
                this.company = (this.$refs.company) ? this.$refs.company.getAttribute('data-init') : '';
                this.name = (this.$refs.name) ? this.$refs.name.getAttribute('data-init') : '';
                this.email = (this.$refs.email) ? this.$refs.email.getAttribute('data-init') : '';
                this.phone = (this.$refs.phone) ? this.$refs.phone.getAttribute('data-init') : '';

                this.$refs.fsecure.style.display = 'none';
            }

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {
        }
    });

})();